// src/pages/Maintenance.tsx
import React from "react";
import styled from "styled-components";
import rovrliveLogo from "@assets/img/login-logo.svg";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAppDispatch } from "@src/redux/hooks";
import { bypassMaintenance } from "@src/redux/slices/maintenanceSessionSlice";

const schema = yup.object().shape({
  password: yup.string().required("Password is required"),
});

const MaintenanceWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.darkBg};
  color: ${({ theme }) => theme.colors.white};
  width: 100vw;
  height: 100vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: ${({ theme }) => theme.margins.medium};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.margins.medium};
  width: 300px;
`;

const Input = styled.input`
  padding: 10px;
  border-radius: 4px;
  border: none;
  outline: none;
`;

const Button = styled.button`
  padding: 10px;
  border-radius: 4px;
  border: none;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
  font-weight: bold;
`;

const Error = styled.p`
  color: ${({ theme }) => theme.colors.red};
  font-size: 0.9rem;
`;

const Logo = styled.img`
  margin-top: ${({ theme }) => theme.margins["2xl"]};
  width: 160px;
  height: auto;
`;

export const MaintenanceLoginPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ password: string }>({
    resolver: yupResolver(schema),
  });

  const onSubmit = ({ password }: { password: string }) => {
    if (
      password ===
      (process.env.REACT_APP_MAINTENANCE_PASSWORD || "JustForTesting!")
    ) {
      localStorage.setItem("maintenance_bypass", "true");
      dispatch(bypassMaintenance());
      location.reload();
    } else {
      alert("Invalid password");
    }
  };

  return (
    <MaintenanceWrapper>
      <Title>ROVR Maintenance Access</Title>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Input
          type="password"
          placeholder="Enter access password"
          {...register("password")}
        />
        {errors.password && <Error>{errors.password.message}</Error>}
        <Button type="submit">Enter</Button>
      </Form>
      <Logo src={rovrliveLogo} alt="ROVR Logo" />
    </MaintenanceWrapper>
  );
};
